module.exports = __webpack_public_path__ + "d19a8ee928c65adb5fb75e045b2442f5.svg";